module.exports = __webpack_public_path__ + "img/About_Freelancers_LIGHT-02.ff03552.svg";